import styled from '@emotion/styled';
import MicrositeHero, { type MicrositeHeroProps } from '~/components/MicrositeHero';
import { css_background, css_fill, css_medium_up, css_small_down, css_stroke } from '~/emotion/theme';

export const Hero = styled.div<{ height?: number }>`
	width: 100%;
	height: ${({ height }) => (height ? `min(${height}vh, calc(100vw * ${height / 100}))` : '100vh')};
`;

const Outer = styled.header<{ height?: number }>`
	position: relative;
	background: ${css_background()};

	@media (${css_small_down}) {
		border-bottom: 1px solid ${css_stroke()};
	}
`;

const Inner = styled.div`
	display: flex;
	flex-direction: column;
	padding-left: ${(props) => props.theme.margin.left};
	padding-right: ${(props) => props.theme.margin.right};

	@media (${css_medium_up}) {
		z-index: 1;
		position: absolute;
		inset: 0;
	}

	@media (${css_small_down}) {
		background: ${css_fill()};
	}

	> * {
		flex: 1;
	}
`;

interface HeroLayoutProps extends MicrositeHeroProps {
	children: React.ReactNode;
	height?: number;
}

export function HeroLayout({ children, height, ...hero }: HeroLayoutProps) {
	return (
		<Outer>
			<Hero height={height}>
				<MicrositeHero {...hero} />
			</Hero>
			<Inner>{children}</Inner>
		</Outer>
	);
}
